import { createApp, h } from 'vue'
import VueTelInput from 'vue3-tel-input'
import { createI18n } from 'vue-i18n'
import 'vue3-tel-input/dist/vue3-tel-input.css'
import './style.css'
import App from './App.vue'
import LoginForm from './components/auth/LoginForm.vue'
import LoginModal from './components/auth/LoginModal.vue'
import ChangePhoneForm from './components/auth/ChangePhoneForm.vue'
import EditPhoneField from './components/account/EditPhoneField.vue'
import { t } from './utils/translate'

window.VUE_OPTIONS_API = true;
window.VUE_PROD_DEVTOOLS = true;

const i18n = createI18n({
    legacy: false,
    locale: 'fa',
    fallbackLocale: 'en',
    messages: {
        fa: window.sms_ir_login?.translations || {}
    }
})

const createVueApp = (component, element) => {
    try {
        const app = createApp({
            render() {
                return h(component)
            }
        });

        app.use(i18n)

        app.config.globalProperties.$t = t;

        const vueTelInputOptions = {
            mode: 'international',
            onlyCountries: ['IR'],
            defaultCountry: 'IR',
            preferredCountries: ['IR'],
            validCharactersOnly: true,
            inputOptions: {
                showDialCode: true,
                placeholder: t('phoneOrEmail')
            },
            format: 'International'
        }

        app.use(VueTelInput, vueTelInputOptions);
        app.mount(element);

        return app;
    } catch (error) {
        console.error('Error creating Vue app:', error);
    }
}

const adminApp = document.getElementById('app');
if (adminApp) {
    const app = createApp(App);
    app.use(i18n);
    app.use(VueTelInput);
    app.config.globalProperties.$t = t;
    app.mount('#app');
}

document.querySelectorAll('[id^="smsir-login-app-"]').forEach(element => {
    createVueApp(LoginForm, `#${element.id}`);
});

document.querySelectorAll('[id^="smsir-login-modal-app-"]').forEach(element => {
    createVueApp(LoginModal, `#${element.id}`);
});

const changePhoneApp = document.getElementById('smsir-change-phone-app');
if (changePhoneApp) {
    createVueApp(ChangePhoneForm, '#smsir-change-phone-app');
}

const editPhoneField = document.getElementById('smsir-edit-phone-field')
if (editPhoneField) {
    createVueApp(EditPhoneField, '#smsir-edit-phone-field')
}
